<div
  *transloco="let t; read: 'calculator_result.result.values.monthly-values'"
  class="flex flex-col gap-2 font-bold">
  <psc-section-title
    *ngIf="showTitle"
    [title]="t('title') + ' (' + (monthsLocalized[_selectedMonth] | titlecase) + ', ' + currentYear + '):'"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="0"
    [lineThickness]="0"></psc-section-title>

  <div class="'flex flex-col'">
    <!-- t(total-consumption-kwh.title, total-consumption-kwh.info, total-production-kwh.title, total-production-kwh.info, feed-in-energy-to-grid-kwh.title, feed-in-energy-to-grid-kwh.info)  -->
    <!--  t(energy-from-grid-kwh.title, energy-from-grid-kwh.info, saving-energy-from-power-plant-kwh.title, saving-energy-from-power-plant-kwh.info)-->
    <!--  t(consumption-month-bill-money.title, consumption-month-bill-money.info, monthly-saving-money.title, monthly-saving-money.info, actual-bill-money.title, actual-bill-money.info)-->
    <!--  t(saving-energy-from-power-plant.title, saving-energy-from-power-plant.info, feed-in-to-grid.title, feed-in-to-grid.info)-->
    <!--  t(peak-power-price-per-kw.title, peak-power-price-per-kw.info, power-peak-money.title, power-peak-money.info, power-peak-money-after-solar.title, power-peak-money-after-solar.info)-->
    <!--  t(peak-power-saving-money.title, peak-power-saving-money.info)-->
    <psc-value-text
      *ngFor="let value of monthlyValues; let even = even; let index = index"
      [coloredRow]="even"
      [label]="t(value.labelKey + '.title')"
      [value]="value.value"
      [unit]="value.unit"
      [infoText]="t(value.labelKey + '.info')"
    ></psc-value-text>
  </div>
</div>
